// src/js/modules/external-links.js
export default function initExternalLinks() {
  const links = document.querySelectorAll('a[href]');
  
  links.forEach(link => {
	const href = link.getAttribute('href');
	
	// Si es externo (empieza con http:// o https://)
	if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
	  // Y no es del mismo dominio
	  if (!href.includes(window.location.hostname)) {
		link.setAttribute('target', '_blank');
		link.setAttribute('rel', 'noopener noreferrer');
		
		// Solo añadir la clase si NO es un botón de compartir
		if (!link.classList.contains('icon-btn')) {
		  link.classList.add('link-external');
		}
	  }
	}
  });
  
  console.log('External links initialized');
}